import Head from "next/head";
import Link from "next/link";

export default function Curiosity() {
	return (
		<>
			<Head>
				<title key="title">Curiosity | Lucien Smith - Seeds</title>
			</Head>
			<div className="mt-6 max-w-full">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center mt-14">Curiosity killed the cat.</h1>
				<div className="text-lg leading-7 mt-5">
					<p className="mt-6">Intersubjectivity is a shared agreement of meaning between multiple people.</p>

					<p className="mt-6">Intersubjective truths, are defined by society. Truths change as our society evolves and our morals progress.</p>

					<p className="mt-6">How do you we change truths?</p>
					<p className="mt-6">
						We must create what others can&rsquo;t comprehend, imagine, or articulate so that we can eventually get to a place where we can
						acknowledge the key responsibilities within society and gravitate to a common rhythm.
					</p>
					<p className="mt-6">
						People are usually afraid of change because they fear the unknown. But the single greatest constant of history is that everything
						changes.*
					</p>
					<p className="mt-6">
						Together the masks of cynicism, an irony and defense could be loosened a little after daylights, hypocrisy of what the world promises and
						what the world delivers fades with the sunset.*
					</p>
					<p className="mt-6">
						He who fights with monsters might take care lest he thereby become a monster. And if you gaze for long into a abyss, the abyss gazes also
						into you.*
					</p>
					<p className="mt-6">
						&ldquo;He went on to explain that when you start performing, you play for people who are just like you, and that&rsquo;s not really
						performing. Then you perform for people who just like you, and that&rsquo;s really fun. Then, &ldquo;if you&rsquo;re lucky,&rdquo; you end
						up performing for people who want to be you, and that&rsquo;s really not as much fun because these people who want to be you always hate
						you a little because they&rsquo;re not you. They secretly want you to fail so you can know how it feels to be them.
						&ldquo;Actually,&rdquo; he said, &ldquo;it&rsquo;s not that complicated. There&rsquo;s a lot of people in a room. One guy&rsquo;s got the
						microphone. Everybody else&rsquo;s got the beer. They&rsquo;re all having about the same amount of fun.&rdquo;*
					</p>
				</div>
				<div className="mt-6">
					<Link href="/important">
						<a className="mt-14">Maybe you should rest your eyes? No? Ok well here&rsquo;s some more for you hungry hungry hippo.</a>
					</Link>
				</div>
			</div>
		</>
	);
}
